var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0001 5.10345C19.383 5.10345 5.10352 19.3829 5.10352 37C5.10352 54.6171 19.383 68.8966 37.0001 68.8966C54.6172 68.8966 68.8966 54.6171 68.8966 37C68.8966 19.3829 54.6172 5.10345 37.0001 5.10345ZM53.5863 39.5517H39.5518V53.5862C39.5518 54.263 39.283 54.912 38.8044 55.3906C38.3259 55.8691 37.6768 56.1379 37.0001 56.1379C36.3233 56.1379 35.6743 55.8691 35.1957 55.3906C34.7172 54.912 34.4483 54.263 34.4483 53.5862V39.5517H20.4139C19.7371 39.5517 19.0881 39.2829 18.6095 38.8043C18.131 38.3258 17.8621 37.6768 17.8621 37C17.8621 36.3232 18.131 35.6742 18.6095 35.1957C19.0881 34.7171 19.7371 34.4483 20.4139 34.4483H34.4483V20.4138C34.4483 19.737 34.7172 19.088 35.1957 18.6095C35.6743 18.1309 36.3233 17.8621 37.0001 17.8621C37.6768 17.8621 38.3259 18.1309 38.8044 18.6095C39.283 19.088 39.5518 19.737 39.5518 20.4138V34.4483H53.5863C54.263 34.4483 54.9121 34.7171 55.3906 35.1957C55.8692 35.6742 56.138 36.3232 56.138 37C56.138 37.6768 55.8692 38.3258 55.3906 38.8043C54.9121 39.2829 54.263 39.5517 53.5863 39.5517Z",
    fill: "#1F91E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddblue);
export default __webpack_public_path__ + "static/media/addblue.02bf24d777ae47ad8e71cdae28cc5f89.svg";
export { ForwardRef as ReactComponent };